// extracted by mini-css-extract-plugin
export default {"debtTypes":"DebtTypes_debtTypes__W0HdD","subtitle":"DebtTypes_subtitle__pk9gh","holder":"DebtTypes_holder__eoRE0","item":"DebtTypes_item__L37VD","checked":"DebtTypes_checked__uaSJi"};